import React from 'react';
import PropTypes from 'prop-types';
import {useStyles, Icon, attachmentIcon} from '@ace-de/ui-components';

const Attachment = props => {
    const {cx} = useStyles(props);
    const {handleOnDownload, attachment} = props;

    if (!attachment) return null;

    return (
        <span
            className={cx([
                'global!ace-u-flex',
                'global!ace-u-flex--align-center',
                'global!ace-u-typography--variant-body',
                'global!ace-u-typography--color-highlighted',
                'global!ace-u-cursor--pointer',
                'global!ace-u-margin--bottom-4',
            ])}
            onClick={() => handleOnDownload(attachment)}
        >
            <Icon
                icon={attachmentIcon}
                className={cx([
                    'global!ace-u-margin--right-8',
                    'ace-c-icon--color-highlight',
                ])}
            />
            {attachment.fileName}
        </span>
    );
};

Attachment.propTypes = {
    handleOnDownload: PropTypes.func.isRequired,
    attachment: PropTypes.object,
};

Attachment.defaultProps = {
    attachment: null,
};

export default Attachment;
